// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var ViewStack = require("../../../reason/common/ViewStack.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var ConversationMessageArea = require("../../../reason/conversations/components/ConversationMessageArea.bs.js");
var ConversationInput__Attachments = require("../../../reason/conversations/components/ConversationInput__Attachments.bs.js");

function Conversation__ConversationsSection__ConversationMessageArea(props) {
  var __focusOnMount = props.focusOnMount;
  var attachmentsManager = props.attachmentsManager;
  var form = props.form;
  var focusOnMount = __focusOnMount !== undefined ? __focusOnMount : false;
  var match = React.useState(function () {
        return false;
      });
  var setInputIsFocused = match[1];
  var fallbackRef = React.useRef(null);
  var inputRef = Core__Option.getOr(props.inputRef, fallbackRef);
  React.useEffect((function () {
          var match = inputRef.current;
          if (focusOnMount && !(match == null)) {
            match.focus({
                  preventScroll: true
                });
          }
          
        }), []);
  var attachments = attachmentsManager.attachments;
  return JsxRuntime.jsx(ConversationMessageArea.make, {
              isFocused: match[0],
              inputRef: inputRef,
              text: form.input.text,
              onChangeText: (function (text) {
                  form.updateText((function (input, text) {
                          return {
                                  text: text,
                                  attachments: input.attachments
                                };
                        }), text);
                }),
              textInputDisabled: form.submitting,
              onFocus: (function (param) {
                  setInputIsFocused(function (param) {
                        return true;
                      });
                }),
              onBlur: (function (param) {
                  setInputIsFocused(function (param) {
                        return false;
                      });
                }),
              onKeyDown: (function (e) {
                  if (e.key === "Enter" && e.metaKey && form.valid()) {
                    return form.submit();
                  }
                  
                }),
              attachments: Caml_option.some(attachments.length !== 0 ? JsxRuntime.jsx("div", {
                          children: JsxRuntime.jsx(ConversationInput__Attachments.make, {
                                uploads: attachments,
                                onDeleteAttachment: attachmentsManager.delete
                              }),
                          className: "pt-1"
                        }) : null),
              buttons: Caml_option.some(JsxRuntime.jsxs(ViewStack.make, {
                        justifyContent: "spaceBetween",
                        flexDirection: "row",
                        children: [
                          JsxRuntime.jsx(ConversationInput__Attachments.AddButton.make, {
                                onAddAttachment: attachmentsManager.add
                              }),
                          JsxRuntime.jsx(ViewStack.make, {
                                alignItems: "center",
                                justifyContent: "flexEnd",
                                flexDirection: "row",
                                children: Caml_option.some(props.submitButtons)
                              })
                        ]
                      })),
              placeholder: props.placeholder
            });
}

var ConversationMessageForm;

var make = Conversation__ConversationsSection__ConversationMessageArea;

exports.ConversationMessageForm = ConversationMessageForm;
exports.make = make;
/* react Not a pure module */
